export default __webpack_public_path__ + "static/media/Hats06.394536a9.png";